import { WSElementProps } from "@wingspanhq/fe-component-library";
import { queriesInvoiceRows } from "@query";
import { Tabs } from "../../../../components/Tabs";
import { selectorInvoiceRowsFilter } from "../../selectors/selectorInvoiceRowsFilter";
import {
  INVOICE_STATUSES_DEPOSITED,
  INVOICE_STATUSES_DRAFT,
  INVOICE_STATUSES_IN_PROGRESS,
  INVOICE_STATUSES_OUTSTANDING,
  INVOICE_STATUSES_REFUNDED
} from "../../types";

// The counts only need the response `summary`, so fetch a single row per tab.
const COUNT_PAGE = { size: 1 };

export const DashboardTabs: React.FC<WSElementProps> = props => {
  const queryAll = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE
  });
  const queryDrafts = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE,
    filter: selectorInvoiceRowsFilter({ statuses: INVOICE_STATUSES_DRAFT })
  });
  const queryOutstanding = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE,
    filter: selectorInvoiceRowsFilter({
      statuses: INVOICE_STATUSES_OUTSTANDING
    })
  });
  const queryInProgress = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE,
    filter: selectorInvoiceRowsFilter({
      statuses: INVOICE_STATUSES_IN_PROGRESS
    })
  });
  const queryDeposited = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE,
    filter: selectorInvoiceRowsFilter({
      statuses: [...INVOICE_STATUSES_DEPOSITED, ...INVOICE_STATUSES_REFUNDED]
    })
  });

  return (
    <Tabs
      {...props}
      tabs={[
        {
          label: "All",
          path: "/member/invoices",
          badge: queryAll.data?.summary?.count
        },
        {
          label: "Drafts",
          path: "/member/invoices/drafts",
          badge: queryDrafts.data?.summary?.count
        },
        {
          label: "Outstanding",
          path: "/member/invoices/outstanding",
          badge: queryOutstanding.data?.summary?.count
        },
        {
          label: "In-progress",
          path: "/member/invoices/in-progress",
          badge: queryInProgress.data?.summary?.count
        },
        {
          label: "Deposited",
          path: "/member/invoices/deposited",
          badge: queryDeposited.data?.summary?.count
        }
      ]}
    />
  );
};
